/** @jsx h */
import { h } from 'preact'
import { createContext, useContext, useMemo } from 'preact/compat'
import tmpl from 'templite'

const LabelContext = createContext()

const LabelProvider = ({ children, labels }) => {
  const value = useMemo(
    () => (key, params) => {
      try {
        const splitted = key.split('.')
        const item = labels[splitted[0]].find(el => el.name === splitted[1])
        return tmpl(item.value, params)
      } catch (err) {
        return key
      }
    },
    [labels]
  )

  return <LabelContext.Provider value={value}>{children}</LabelContext.Provider>
}

const useLabel = () => {
  return useContext(LabelContext)
}

export { LabelProvider, useLabel }
